module.exports = __WEBPACK_EXTERNAL_MODULE_29__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.object.define-property"
// module id = 29
// module chunks = 0